import React from 'react';
import { Collapse, TableBody } from '@material-ui/core';
import { Color } from '../../../generated/graphql';
import { StripedNestedTable } from './style';

interface NestedTableProps {
    isOpen?: boolean;
    startOdd?: boolean;
    stripeColor?: Color;
}

const NestedCollapsibleTable: React.FC<NestedTableProps> = ({ children, isOpen, startOdd, stripeColor }) => {
    return (
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <StripedNestedTable color={stripeColor} startOdd={startOdd}>
                <TableBody>
                    {children}
                </TableBody>
            </StripedNestedTable>
        </Collapse>
    );
};

export default NestedCollapsibleTable;
